// // src/components/inventory/InventoryList.js
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { dbHelpers } from '../../db/database';
// import { productsAPI, warehousesAPI, stocksAPI } from '../../api';
// import { useOfflineData } from '../../hooks/useOfflineData';
// import { useToast } from '../../hooks/useToast';
// import { useModal } from '../../hooks/useModal';
// import Modal from '../common/Modal';
// import { usePermissions, filterWarehouses } from '../../utils/permissions';
// import './InventoryList.css';

// function InventoryList() {
//   const navigate = useNavigate();
//   const toast = useToast();
//   const { isOpen, modalConfig, openModal, closeModal } = useModal();
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [deleting, setDeleting] = useState(null);
//   const [refreshKey, setRefreshKey] = useState(0); // Changed from refreshTrigger
  
//   const { canCreate, canEdit, canDelete } = usePermissions('products');
  
//   // Add refreshKey as dependency
//   const { data: products, loading: productsLoading, refetch: refetchProducts } = useOfflineData(
//     () => productsAPI.getAll(),
//     dbHelpers.getProducts,
//   );
  
//   const { data: stocks, loading: stocksLoading } = useOfflineData(
//     () => stocksAPI.getAll(),
//     dbHelpers.getStocks
//   );
  
//   const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
//     () => warehousesAPI.getAll(),
//     dbHelpers.getWarehouses
//   );
  
//   const loading = productsLoading || stocksLoading || warehousesLoading;
  
//   const warehouses = filterWarehouses(allWarehouses);

//   // Filter products whenever products or searchTerm changes
//   useEffect(() => {
//     filterProducts();
//   }, [searchTerm, products, refreshKey]); // Added refreshKey as dependency

//   function filterProducts() {
//     if (!searchTerm) {
//       setFilteredProducts(products);
//       return;
//     }
    
//     const filtered = products.filter(p =>
//       p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       p.sku?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//     setFilteredProducts(filtered);
//   }

//   // Force immediate refresh
//   async function forceRefresh() {
//     console.log('🔄 Force refresh initiated...');
    
//     try {
//       // Increment refresh key to trigger useOfflineData
//       setRefreshKey(prev => prev + 1);
      
//       // If refetch function exists, call it
//       if (typeof refetchProducts === 'function') {
//         await refetchProducts();
//       }
      
//       // Re-fetch from IndexedDB directly as backup
//       const freshProducts = await dbHelpers.getProducts();
//       console.log(`📦 Fresh products from DB: ${freshProducts.length} items`);
      
//       // Force filter update
//       if (!searchTerm) {
//         setFilteredProducts(freshProducts);
//       } else {
//         const filtered = freshProducts.filter(p =>
//           p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           p.sku?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//         setFilteredProducts(filtered);
//       }
      
//       console.log('✅ Force refresh completed');
//     } catch (error) {
//       console.error('❌ Force refresh failed:', error);
//     }
//   }

//   async function performDelete(product) {
//     if (!canDelete) {
//       toast.error('You do not have permission to delete products');
//       return;
//     }
    
//     setDeleting(product.id);
    
//     try {
//       if (navigator.onLine) {
//         // Online: Delete via API
//         try {
//           await productsAPI.delete(product.id);
//           console.log('✅ Product deleted from server successfully');
//         } catch (apiError) {
//           // Handle 400 errors specifically
//           if (apiError.response?.status === 400) {
//             const errorMessage = apiError.response?.data?.message || 
//                                 apiError.response?.data?.error || 
//                                 'Bad request';
            
//             console.error('❌ 400 Error Details:', {
//               status: apiError.response.status,
//               message: errorMessage,
//               fullError: apiError.response.data,
//               productId: product.id,
//               productName: product.name
//             });
            
//             // Check if it's because product doesn't exist
//             if (errorMessage.toLowerCase().includes('not found') || 
//                 errorMessage.toLowerCase().includes('does not exist') ||
//                 errorMessage.toLowerCase().includes('product')) {
//               toast.error(`❌ Cannot delete: Product "${product.name}" no longer exists on server`);
//             } else {
//               toast.error(`❌ Delete failed (400): ${errorMessage}`);
//             }
            
//             throw apiError; // Re-throw to prevent local deletion
//           }
          
//           // Handle other HTTP errors
//           if (apiError.response?.status === 404) {
//             console.warn('⚠️ Product not found on server (404) - will delete locally');
//             toast.info('Product not found on server, removing from local database');
//           } else {
//             throw apiError; // Re-throw other errors
//           }
//         }
//       } else {
//         // Offline: Mark for deletion
//         await dbHelpers.markForDeletion('products', product.id);
//         toast.info('⚠️ Offline: Product marked for deletion. Will sync when online.');
//       }
      
//       // Delete from IndexedDB (only if API call succeeded or was offline)
//       await dbHelpers.deleteProduct(product.id);
//       console.log('✅ Product deleted from IndexedDB');
      
//       // Close modal first
//       closeModal();
      
//       // Force refresh with slight delay to ensure DB is updated
//       // setTimeout(async () => {
//       //   await forceRefresh();
//       //   toast.success('✅ Product deleted successfully');
//       // }, 100);
//       setTimeout(() => window.location.reload(), 50)

      
//     } catch (error) {
//       console.error('❌ Delete failed:', error);
      
//       let errorMessage = 'Failed to delete product';
      
//       if (error.response) {
//         const status = error.response.status;
//         const data = error.response.data;
        
//         errorMessage = `Failed to delete (${status}): ${
//           data?.message || 
//           data?.error || 
//           data?.detail || 
//           'Unknown error'
//         }`;
        
//         console.error('Error details:', {
//           status,
//           statusText: error.response.statusText,
//           data,
//           headers: error.response.headers
//         });
//       } else if (error.request) {
//         errorMessage = 'No response from server - check your connection';
//         console.error('No response received:', error.request);
//       } else {
//         errorMessage = error.message || 'Unknown error occurred';
//         console.error('Error message:', error.message);
//       }
      
//       toast.error(errorMessage);
      
//     } finally {
//       setDeleting(null);
//     }
//   }



//   function handleDelete(product) {
//     openModal({
//       title: 'Delete Product',
//       message: `Are you sure you want to delete "${product.name}"? This action cannot be undone.`,
//       type: 'danger',
//       onConfirm: () => performDelete(product)
//     });
//   }

//   if (loading) {
//     return (
//       <div className="inventory-list">
//         <div className="loading-state">
//           <div className="spinner"></div>
//           <p>Loading products...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="inventory-list fade-in">
//       <div className="inventory-header">
//         <div>
//           <h1>Inventory</h1>
//           <p className="subtitle">{products.length} products in stock</p>
//         </div>
//         <div style={{display: 'flex', gap: '12px'}}>
//           {canCreate && (
//             <>
//               <button onClick={() => navigate('/inventory/new')} className="btn-primary">
//                 ➕ Add Product
//               </button>
//             </>
//           )}
//         </div>
//       </div>

//       <div className="inventory-controls">
//         <input
//           type="text"
//           className="search-input"
//           placeholder="🔍 Search products..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       {filteredProducts.length === 0 ? (
//         <div className="empty-state">
//           <div className="empty-icon">📦</div>
//           <p className="empty-title">No products found</p>
//           <p className="empty-desc">Try adjusting your search term</p>
//         </div>
//       ) : (
//         <div className="products-grid">
//           {filteredProducts.map(product => (
//             <div key={product.id} className="product-card">
//               <div className="product-header">
//                 <div>
//                   <h3>{product.name}</h3>
//                   <div className="sku">SKU: {product.sku}</div>
//                 </div>
//               </div>
              
//               <div className="product-details">
//                 {product.category && (
//                   <div className="category">
//                     <span className="label">Category:</span>
//                     <span className="value">{product.category}</span>
//                   </div>
//                 )}



// {product.has_variants && product.variants && product.variants.length > 0 && (
//   <div className="category" style={{marginTop: '8px'}}>
//     <span className="label">Variants:</span>
//     <span className="value">{product.variants.length} variant{product.variants.length > 1 ? 's' : ''}</span>
//     <div style={{display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px'}}>
//       {product.variants.slice(0, 3).map((v, idx) => (
//         <span key={idx} style={{
//           background: '#1f2937',
//           padding: '2px 8px',
//           borderRadius: '4px',
//           fontSize: '0.75em',
//           color: '#10b981'
//         }}>
//           {v.color} {v.size}
//         </span>
//       ))}
//       {product.variants.length > 3 && (
//         <span style={{fontSize: '0.75em', color: '#9ca3af'}}>
//           +{product.variants.length - 3}
//         </span>
//       )}
//     </div>
//   </div>
// )}                
//                 <div className="price-info">
//                   <div className="price-item">
//                     <span className="label">Buying Price:</span>
//                     <span className="value">TSh {parseFloat(product.buying_price || 0).toFixed(2)}</span>
//                   </div>
//                   <div className="price-item">
//                     <span className="label">Selling Price:</span>
//                     <span className="value price">TSh {parseFloat(product.selling_price || 0).toFixed(2)}</span>
//                   </div>
//                 </div>
//               </div>
            
//               <div className="product-footer">
//                 {canEdit && (
//                   <button 
//                     className="btn-action" 
//                     onClick={() => navigate(`/inventory/edit/${product.id}`)}
//                   >
//                     Edit
//                   </button>
//                 )}
                
//                 {canDelete && (
//                   <button 
//                     className="btn-action btn-delete" 
//                     onClick={() => handleDelete(product)}
//                     disabled={deleting === product.id}
//                   >
//                     {deleting === product.id ? '⏳' : 'Delete'}
//                   </button>
//                 )}
                
//                 {!canEdit && !canDelete && (
//                   <button 
//                     className="btn-action" 
//                     onClick={() => navigate(`/inventory/edit/${product.id}`)}
//                   >
//                     View
//                   </button>
//                 )}
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       <Modal 
//         isOpen={isOpen}
//         onClose={closeModal}
//         {...modalConfig}
//       />
//     </div>
//   );
// }

// export default InventoryList;



// src/components/inventory/InventoryList.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { dbHelpers } from '../../db/database';
import { productsAPI, warehousesAPI, stocksAPI } from '../../api';
import { useOfflineData } from '../../hooks/useOfflineData';
import { useToast } from '../../hooks/useToast';
import { useModal } from '../../hooks/useModal';
import Modal from '../common/Modal';
import { usePermissions, filterWarehouses } from '../../utils/permissions';
import './InventoryList.css';

function InventoryList() {
  const navigate = useNavigate();
  const toast = useToast();
  const { isOpen, modalConfig, openModal, closeModal } = useModal();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [deleting, setDeleting] = useState(null);

  const { canCreate, canEdit, canDelete } = usePermissions('products');

  const { data: products, loading: productsLoading } = useOfflineData(
    () => productsAPI.getAll(),
    dbHelpers.getProducts,
  );

  const { data: stocks, loading: stocksLoading } = useOfflineData(
    () => stocksAPI.getAll(),
    dbHelpers.getStocks
  );

  const { data: allWarehouses, loading: warehousesLoading } = useOfflineData(
    () => warehousesAPI.getAll(),
    dbHelpers.getWarehouses
  );

  const loading = productsLoading || stocksLoading || warehousesLoading;

  useEffect(() => {
    if (!searchTerm) {
      setFilteredProducts(products);
      return;
    }
    const filtered = products.filter(p =>
      p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.sku?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredProducts(filtered);
  }, [searchTerm, products]);

  async function performDelete(product) {
    if (!canDelete) {
      toast.error('You do not have permission to delete products');
      return;
    }

    setDeleting(product.id);

    try {
      if (navigator.onLine) {
        try {
          await productsAPI.delete(product.id);
        } catch (apiError) {
          if (apiError.response?.status === 400) {
            const errorMessage = apiError.response?.data?.message ||
              apiError.response?.data?.error || 'Bad request';
            if (errorMessage.toLowerCase().includes('not found') ||
              errorMessage.toLowerCase().includes('does not exist') ||
              errorMessage.toLowerCase().includes('product')) {
              toast.error(`❌ Cannot delete: Product "${product.name}" no longer exists on server`);
            } else {
              toast.error(`❌ Delete failed (400): ${errorMessage}`);
            }
            throw apiError;
          }
          if (apiError.response?.status === 404) {
            toast.info('Product not found on server, removing from local database');
          } else {
            throw apiError;
          }
        }
      } else {
        await dbHelpers.markForDeletion('products', product.id);
        toast.info('⚠️ Offline: Product marked for deletion. Will sync when online.');
      }

      await dbHelpers.deleteProduct(product.id);
      closeModal();

      // ✅ Remove from UI state directly — no reload needed
      setFilteredProducts(prev => prev.filter(p => p.id !== product.id));
      toast.success('✅ Product deleted successfully');

    } catch (error) {
      let errorMessage = 'Failed to delete product';
      if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        errorMessage = `Failed to delete (${status}): ${data?.message || data?.error || data?.detail || 'Unknown error'}`;
      } else if (error.request) {
        errorMessage = 'No response from server - check your connection';
      } else {
        errorMessage = error.message || 'Unknown error occurred';
      }
      toast.error(errorMessage);
    } finally {
      setDeleting(null);
    }
  }

  function handleDelete(product) {
    openModal({
      title: 'Delete Product',
      message: `Are you sure you want to delete "${product.name}"? This action cannot be undone.`,
      type: 'danger',
      onConfirm: () => performDelete(product)
    });
  }

  if (loading) {
    return (
      <div className="inventory-list">
        <div className="loading-state">
          <div className="spinner"></div>
          <p>Loading products...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="inventory-list fade-in">
      <div className="inventory-header">
        <div>
          <h1>Inventory</h1>
          <p className="subtitle">{products.length} products in stock</p>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          {canCreate && (
            <button onClick={() => navigate('/inventory/new')} className="btn-primary">
              ➕ Add Product
            </button>
          )}
        </div>
      </div>

      <div className="inventory-controls">
        <input
          type="text"
          className="search-input"
          placeholder="🔍 Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {filteredProducts.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">📦</div>
          <p className="empty-title">No products found</p>
          <p className="empty-desc">Try adjusting your search term</p>
        </div>
      ) : (
        <div className="products-grid">
          {filteredProducts.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-header">
                <div>
                  <h3>{product.name}</h3>
                  <div className="sku">SKU: {product.sku}</div>
                </div>
              </div>

              <div className="product-details">
                {product.category && (
                  <div className="category">
                    <span className="label">Category:</span>
                    <span className="value">{product.category}</span>
                  </div>
                )}

                {product.has_variants && product.variants && product.variants.length > 0 && (
                  <div className="category" style={{ marginTop: '8px' }}>
                    <span className="label">Variants:</span>
                    <span className="value">{product.variants.length} variant{product.variants.length > 1 ? 's' : ''}</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                      {product.variants.slice(0, 3).map((v, idx) => (
                        <span key={idx} style={{
                          background: '#1f2937',
                          padding: '2px 8px',
                          borderRadius: '4px',
                          fontSize: '0.75em',
                          color: '#10b981'
                        }}>
                          {v.color} {v.size}
                        </span>
                      ))}
                      {product.variants.length > 3 && (
                        <span style={{ fontSize: '0.75em', color: '#9ca3af' }}>
                          +{product.variants.length - 3}
                        </span>
                      )}
                    </div>
                  </div>
                )}

                <div className="price-info">
                  <div className="price-item">
                    <span className="label">Buying Price:</span>
                    <span className="value">TSh {parseFloat(product.buying_price || 0).toFixed(2)}</span>
                  </div>
                  <div className="price-item">
                    <span className="label">Selling Price:</span>
                    <span className="value price">TSh {parseFloat(product.selling_price || 0).toFixed(2)}</span>
                  </div>
                </div>
              </div>

              <div className="product-footer">
                {canEdit && (
                  <button className="btn-action" onClick={() => navigate(`/inventory/edit/${product.id}`)}>
                    Edit
                  </button>
                )}
                {canDelete && (
                  <button
                    className="btn-action btn-delete"
                    onClick={() => handleDelete(product)}
                    disabled={deleting === product.id}
                  >
                    {deleting === product.id ? '⏳' : 'Delete'}
                  </button>
                )}
                {!canEdit && !canDelete && (
                  <button className="btn-action" onClick={() => navigate(`/inventory/edit/${product.id}`)}>
                    View
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal isOpen={isOpen} onClose={closeModal} {...modalConfig} />
    </div>
  );
}

export default InventoryList;